import { connect } from 'react-redux';
import AccessTable from 'project/components/access_table';

export function mapStateToPending({ project }) {
  const ndas = project.ndas.data;
  return {
    ndas: ndas.filter(nda => (nda.request_accepted === null)),
    type: 'pending',
  };
}

export function mapStateToApproved({ project }) {
  const ndas = project.ndas.data;
  return {
    ndas: ndas.filter(nda => (nda.request_accepted === true)),
    type: 'approved',
  };
}

export function mapStateToDenied({ project }) {
  const ndas = project.ndas.data;
  return {
    ndas: ndas.filter(nda => (nda.request_accepted === false)),
    type: 'denied',
  };
}

const wrapperMap = map => state => {
  return {
    isAdmin: state.user.profile_data.is_staff,
    ...map(state)
  };
}

const ApprovedAccess = connect(wrapperMap(mapStateToApproved))(AccessTable);
const DeniedAccess = connect(wrapperMap(mapStateToDenied))(AccessTable);
const PendingAccess = connect(wrapperMap(mapStateToPending))(AccessTable);

export { ApprovedAccess, DeniedAccess, PendingAccess };



// WEBPACK FOOTER //
// ./project/containers/access_types.js